import { useState, type FormEvent } from "react";
import { OpsApiError } from "../lib/api";
import { useAuth } from "./AuthProvider";
import { BrandLockup } from "./BrandLockup";

export function LoginGate() {
  const { loginWithPassword } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await loginWithPassword(username, password);
    } catch (err) {
      const msg =
        err instanceof OpsApiError
          ? err.code === "OPS_ADMIN_DISABLED"
            ? "Ops admin disabled — set CONTENT_ADMIN_API_KEY on API"
            : "Wrong username or password"
          : "Login failed";
      setError(msg);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ops-login">
      <div className="ops-login__wrap">
        <p className="ops-login__caption">运营管理后台</p>
        <div className="ops-login__card">
          <div className="ops-login__brand">
            <BrandLockup size="lg" />
            <p className="ops-login__slogan">发现中国最潮的体验</p>
            <p className="ops-login__tagline">不一样的中国体验</p>
          </div>
          <form className="ops-login__form" onSubmit={onSubmit}>
          <h1>Sign in</h1>
          <label className="ops-login__field">
            <span>Username</span>
            <input
              autoComplete="username"
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              value={username}
            />
          </label>
          <label className="ops-login__field">
            <span>Password</span>
            <input
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              type="password"
              value={password}
            />
          </label>
          {error ? (
            <p className="ops-login__error" role="alert">
              {error}
            </p>
          ) : null}
          <button className="ops-login__submit" disabled={busy || !username.trim() || !password} type="submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        </div>
      </div>
    </div>
  );
}
